/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import { fetchData, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const RestaurantDetailsHeader: React.FC = () => {
  const t = Tr()
  const lang = useLang()
  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;
    
  } else {
    console.log("No vendor data found");
  }
  const location = useLocation();
  const restaurantId = (location.state as any)?.restaurantId || '';
  const [restaurantDetails, setRestaurantDetails] = useState([]);

  // restaurant Details api call
  const restaurantDetailsApiCall=async()=>{
        
    var param:any={
        vendorId:vendorId,
        'restaurantId':restaurantId
    }
    var response:any=await fetchData("public/restaurantDetail",param)
    
    if(response.status=="200")
    {        
        var restaurantData = response.data
        setRestaurantDetails(restaurantData);
    }
    else
    {
        toasterrormsg(response.message)
    }
  }
  useEffect(()=>{
    restaurantDetailsApiCall()
  },[restaurantId])
  return (
    <>
    {
      restaurantDetails.map((restaurant:any,index:any)=>{
        var imageUrl = '';
        var totalImage = '';
        if(restaurant['images'].length != 0){
          imageUrl = restaurant['images'][0].mediaPath;
          totalImage = '+'+(restaurant['images'].length-1);
        }else{
          imageUrl = toAbsoluteUrl("/media/avatars/300-1.jpg");
          totalImage = '';
        }
        return (

          <div className='card mb-5 mb-xl-10' key={index}>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src={imageUrl} alt='vendor avatar' />
                    {
                      totalImage ? (
                        <div className='position-absolute translate-middle top-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-40px w-40px text-white fw-bold fs-4 p-1'>{totalImage}</div>
                      ):('')
                    }
                  </div>
                </div>

                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='text-gray-800 fs-2 fw-bolder me-1'>
                          {getTranslatedValue(lang, restaurant, '_name')}
                        </div>
                        <button
                          className='btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3'
                        >
                          {restaurant['type'] == 'RESTAURANT' ? t('Restaurant') : t('Cafe')}
                        </button>
                      </div>

                      <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                        <div
                          className='d-flex align-items-center text-gray-400 me-5 mb-2'
                        >
                          <KTIcon iconName='sms' className='fs-4 me-1' />
                          {restaurant['email']}
                        </div>
                        <div
                          className='d-flex align-items-center text-gray-400 me-5 mb-2'
                        >
                          <KTIcon iconName='phone' className='fs-4 me-1' />
                          {restaurant['phoneNo']}
                        </div>
                        <div
                          className='d-flex align-items-center text-gray-400 me-5 mb-2'
                        >
                          <KTIcon iconName='geolocation' className='fs-4 me-1' />
                          {restaurant['location']}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='d-flex flex-wrap flex-stack'>
                    <div className='d-flex flex-column flex-grow-1 pe-8'>
                      <div className='d-flex flex-wrap'>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex overflow-auto h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/restaurantoverview/' && 'active')
                      }
                      to='../restaurantoverview/'
                      state={{restaurantId:restaurantId}}
                    >
                      {t('All Details')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )
      })
    }
    </>
  )
}

export {RestaurantDetailsHeader}
